import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Tempotravelleronrentinpimprichichwad() {



  const cardData = {
"keyword": "Tempo Traveller on Rent in Pimpri Chinchwad",

"headingDescription":
  "Aaradhya Travels offers reliable Tempo Traveller on Rent in Pimpri Chinchwad for family trips, corporate travel, weddings, airport transfers, pilgrimage tours, and outstation journeys. Our well-maintained AC Tempo Travellers with pushback seats and experienced drivers ensure safe, spacious, and comfortable group travel across Pune, PCMC, and nearby destinations.",

"topPlaces": [
  {
    "title": "Nashik",
    "description":
      "Nashik is famous for Trimbakeshwar Temple, river ghats, vineyards, and religious tourism. It is a popular destination for pilgrimage groups and sightseeing tours traveling from Pimpri Chinchwad."
  },
  {
    "title": "Khandala",
    "description":
      "Khandala is a scenic hill station famous for misty mountains, valleys, waterfalls, and peaceful natural surroundings. Groups from Pimpri Chinchwad often choose Tempo Traveller rentals for relaxed road journeys and sightseeing trips."
  },
  {
    "title": "Mahabaleshwar",
    "description":
      "Mahabaleshwar is a famous hill station known for strawberry farms, Venna Lake, viewpoints, waterfalls, and cool climate. It is widely preferred for family vacations, corporate outings, and group tours from Pimpri Chinchwad."
  },
  {
    "title": "Panchgani",
    "description":
      "Panchgani is known for Table Land, strawberry farms, scenic valleys, boarding schools, and refreshing climate. Group travelers often book Tempo Travellers for comfortable hill station trips and sightseeing."
  },
  {
    "title": "Shirdi",
    "description":
      "Shirdi is a major pilgrimage destination dedicated to Sai Baba, visited by devotees across India. Tempo Traveller services are commonly used for family darshan trips and spiritual group travel from Pimpri Chinchwad."
  },
  
  {
    "title": "Lonavala",
    "description":
      "Lonavala is one of the most popular hill stations near Pimpri Chinchwad and Pune, known for waterfalls, green valleys, Tiger Point, Bhushi Dam, caves, and scenic monsoon routes. It is a top choice for weekend group trips and family outings by Tempo Traveller."
  },
  {
    "title": "Mumbai",
    "description":
      "Mumbai is a major metro city known for Marine Drive, Gateway of India, beaches, shopping streets, and Bollywood attractions. Corporate groups and families frequently travel from Pimpri Chinchwad via Tempo Traveller."
  },
  {
    "title": "Lavasa",
    "description":
      "Lavasa is a planned hill city near Pune known for lakeside views, colorful architecture, cafes, and adventure activities. It is a popular one-day and weekend group trip destination."
  },
 
],



services: [
  {
    name: "Tempo Traveller on Rent in Pimpri Chinchwad",
    description: "Tempo Traveller on rent in Pimpri Chinchwad service provides comfortable transportation for family tours, airport transfers, corporate outings, wedding travel, educational trips, and outstation journeys. Spacious seating and luggage space ensure smooth travel experiences suitable for local and long-distance routes. Professional chauffeurs ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from residential societies, offices, hotels, and commercial locations across Pimpri Chinchwad Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "17 Seater Tempo Traveller on Rent in Pimpri Chinchwad",
    description: "17 seater Tempo Traveller on rent in Pimpri Chinchwad service offers spacious transportation for group tours, family vacations, pilgrimage journeys, and business travel requirements. Comfortable pushback seating and smooth highway performance ensure pleasant travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and commercial areas across Pimpri Chinchwad Pune. Flexible booking options allow convenient 17 seater traveller reservations."
  },
  {
    name: "13 Seater Tempo Travellers On Rent in Pimpri Chinchwad",
    description: "13 seater Tempo Travellers on rent in Pimpri Chinchwad service provides dependable transportation for small family groups, sightseeing tours, airport transfers, and local or outstation travel. Spacious interiors and comfortable seating ensure smooth travel experiences suitable for tourist and family journeys. Professional drivers ensure safe transportation and punctual pickup services throughout the trip. Pickup services are available from residential societies, offices, hotels, and commercial locations across Pimpri Chinchwad Pune. Flexible booking options allow convenient 13 seater traveller reservations."
  },
  {
    name: "9 12 14 17 20 24 Seater Tempo Traveller on Rent in Pune",
    description: "9 12 14 17 20 24 seater Tempo Traveller on rent in Pune service offers multiple seating options for family vacations, corporate events, wedding travel, educational tours, and outstation journeys. Spacious vehicles ensure comfortable seating and luggage capacity suitable for all passenger groups and travel requirements. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "Tempo Traveller Hire in Hinjewadi",
    description: "Tempo Traveller hire in Hinjewadi service provides reliable transportation for IT professionals, corporate teams, airport transfers, office outings, and group travel requirements. Comfortable seating and spacious interiors ensure smooth travel experiences suitable for business and leisure journeys. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from IT parks, offices, residential societies, hotels, and commercial areas across Hinjewadi Pune. Flexible booking options allow convenient traveller hire reservations."
  },
  {
    name: "Tempo Traveller Hire in Aundh Pune",
    description: "Tempo Traveller hire in Aundh Pune service offers comfortable transportation for family tours, airport transfers, educational trips, business meetings, and outstation journeys. Spacious vehicles ensure smooth travel experiences suitable for tourists, families, and corporate passengers. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, and commercial locations across Aundh Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "Pimpri Chinchwad to Shirdi Tempo Traveller on Rent",
    description: "Pimpri Chinchwad to Shirdi Tempo Traveller on rent service provides reliable transportation for Sai Baba darshan tours, family pilgrimages, and spiritual journeys from Pimpri Chinchwad Pune. Spacious seating and smooth highway travel ensure comfortable journeys suitable for devotees and senior citizens. Professional drivers ensure safe driving and dependable transportation services throughout the Shirdi route. Pickup services are available from homes, offices, hotels, and residential societies across Pimpri Chinchwad Pune. Flexible booking options allow convenient Shirdi traveller reservations."
  },
  {
    name: "Tempo Traveller on Rent in Bhosari",
    description: "Tempo Traveller on rent in Bhosari service offers dependable transportation for airport transfers, family outings, corporate travel, wedding functions, and outstation journeys. Spacious interiors and comfortable seating ensure pleasant travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, industrial areas, and commercial locations across Bhosari Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "Tempo Traveller on Rent in Nigdi Pune",
    description: "Tempo Traveller on rent in Nigdi Pune service provides comfortable transportation for local sightseeing, family vacations, airport transfers, educational tours, and group travel requirements. Spacious seating and luggage capacity ensure smooth travel experiences suitable for long-distance journeys. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from residential societies, offices, hotels, and commercial areas across Nigdi Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "Tempo Traveller on Rent in Ravet Pune",
    description: "Tempo Traveller on rent in Ravet Pune service offers spacious transportation for corporate outings, wedding travel, airport transfers, family functions, and outstation trips. Comfortable interiors and smooth highway performance ensure pleasant travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, and residential locations across Ravet Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "Tempo Traveller on Rent in Chinchwad Pune",
    description: "Tempo Traveller on rent in Chinchwad Pune service provides dependable transportation for family tours, business travel, educational trips, airport transfers, and pilgrimage journeys. Spacious seating and luggage space ensure comfortable travel experiences suitable for local and outstation routes. Professional chauffeurs ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from homes, offices, hotels, and commercial areas across Chinchwad Pune. Flexible booking options allow convenient traveller reservations."
  },
  {
    name: "Tempo Traveller Service in Pune",
    description: "Tempo Traveller service in Pune offers reliable transportation for group tours, sightseeing trips, airport transfers, wedding travel, office outings, and outstation journeys. Comfortable seating and spacious interiors ensure smooth travel experiences suitable for tourists, families, and corporate passengers. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient traveller service reservations."
  }
],

tableData: [
  ["Tempo Traveller on Rent in Pimpri Chinchwad", "17 Seater Tempo Traveller on Rent in Pimpri Chinchwad"],
  ["13 Seater Tempo Travellers On Rent in Pimpri Chinchwad", "9 12 14 17 20 24 Seater Tempo Traveller on Rent in Pune"],
  ["Tempo Traveller Hire in Hinjewadi", "Tempo Traveller Hire in Aundh Pune"],
  ["Pimpri Chinchwad to Shirdi Tempo Traveller on Rent", "Tempo Traveller on Rent in Bhosari"],
  ["Tempo Traveller on Rent in Nigdi Pune", "Tempo Traveller on Rent in Ravet Pune"],
  ["Tempo Traveller on Rent in Chinchwad Pune", "Tempo Traveller Service in Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Tempo Traveller on Rent in Pimpri Chinchwad",
        WhyChoosedescription: "Aaradhya Travels provides reliable Tempo Traveller rental service in Pimpri Chinchwad with comfortable vehicles, professional drivers, and smooth travel arrangements for family tours, corporate trips, and group travel."
      },
      {
        WhyChooseheading: "Affordable Tempo Traveller Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Tempo Traveller on rent in Pimpri Chinchwad with transparent pricing, flexible booking plans, and complete travel assistance without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Tempo Traveller Booking Service",
        WhyChoosedescription: "Our Tempo Traveller rental service in Pimpri Chinchwad operates 24 hours for airport transfers, weddings, corporate outings, outstation tours, pilgrimage journeys, and holiday travel."
      },
      {
        WhyChooseheading: "Comfortable & Fully AC Tempo Travellers",
        WhyChoosedescription: "All Tempo Travellers provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained to provide safe and comfortable travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Group Tours",
        WhyChoosedescription: "Aaradhya Travels offers customized one-day trips, weekend tours, multi-day outstation journeys, and flexible travel packages according to customer travel requirements."
      },
      {
        WhyChooseheading: "13, 17 & 20 Seater Tempo Traveller Options",
        WhyChoosedescription: "Customers can choose from 13 seater, 17 seater, and 20 seater Tempo Travellers suitable for family vacations, tourist groups, office teams, and wedding travel."
      },
      {
        WhyChooseheading: "Pickup Available Across Pimpri Chinchwad",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from homes, hotels, railway stations, offices, and all major Pimpri Chinchwad locations including Akurdi, Nigdi, Chinchwad, Bhosari, and Pimple Saudagar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Highway Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for local and outstation group transportation requirements."
      }
    ]
  };

  const faqData = [
    { question: "What is Tempo Traveller on rent in Pimpri Chinchwad?", answer: "Tempo Traveller rental service in Pimpri Chinchwad provides comfortable group transportation for family trips, corporate travel, weddings, and outstation tours." },
    { question: "Is Tempo Traveller booking available 24 hours in Pimpri Chinchwad?", answer: "Yes, Aaradhya Travels provides 24/7 Tempo Traveller rental service in Pimpri Chinchwad." },
    { question: "Which Tempo Traveller seating options are available?", answer: "Aaradhya Travels offers 13 seater, 17 seater, and 20 seater Tempo Travellers for different group travel requirements." },
    { question: "Can I book Tempo Traveller for outstation travel?", answer: "Yes, customers can book Tempo Travellers for outstation tours, hill station trips, pilgrimage journeys, and holiday travel." },
    { question: "Do you provide Tempo Travellers for corporate events?", answer: "Yes, Aaradhya Travels provides Tempo Traveller rental service for corporate meetings, office outings, conferences, and employee transportation." },
    { question: "Are all Tempo Travellers air-conditioned?", answer: "Yes, all Tempo Travellers are fully air-conditioned and maintained for comfortable group travel." },
    { question: "Can I book Tempo Traveller online in Pimpri Chinchwad?", answer: "Yes, customers can easily book Tempo Traveller rental service online or through phone booking." },
    { question: "Do you provide Tempo Travellers for weddings and family tours?", answer: "Yes, Aaradhya Travels provides spacious Tempo Travellers suitable for weddings, family vacations, and group tours." },
    { question: "Are Tempo Traveller rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Tempo Traveller rental service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Mahesh Patil",
    feedback:
      "Traveling across Pimpri Chinchwad with a group became very easy with Aaradhya Travels arranging a Tempo Traveller. The ride was comfortable, and everyone could travel together without any confusion.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Pooja Deshmukh",
    feedback:
      "Aaradhya Travels provided a Tempo Traveller on rent in Pimpri Chinchwad for our family function, and the experience was very well managed. The vehicle was clean, spacious, and the journey felt smooth throughout.",
    rating: 5
  }
];







  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tempo Traveller on Rent in Pimpri Chinchwad",
  "image": "https://www.aaradhyatravels99.com/assets/images/tempo-traveller-on-rent-pimpri-chinchwad.jpg",
  "description": "Book Tempo Traveller on rent in Pimpri Chinchwad with Aaradhya Travels for family trips, corporate tours, weddings, airport transfers, and outstation travel. Affordable 9, 12, 13, 14, 17, 20, and 24 seater tempo traveller available across Pune, Hinjewadi, Aundh, Bhosari, Nigdi, Ravet, and Chinchwad.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3672"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/tempo-traveller-on-rent-in-pimpri-chinchwad"
  }
};




  return (
    <div>

<Helmet>
  <title>
    Tempo Traveller on Rent in Pimpri Chinchwad | AC Bus Hire Pune | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Tempo Traveller on rent in Pimpri Chinchwad with Aaradhya Travels. Affordable 9 to 24 seater tempo traveller available for Hinjewadi, Aundh, Bhosari, Nigdi, Ravet, Chinchwad, Shirdi trips, corporate tours, weddings, and outstation travel."
  />

  <meta
    name="keywords"
    content="Tempo traveller on rent in pimpri chinchwad, 17 Seater tempo traveller on rent in pimpri chinchwad, 13 Seater Tempo Travellers On Rent in Pimpri Chinchwad, 9,12,14,17,20,24 Seater Tempo Traveller on Rent in Pune, Tempo Traveller Hire in Hinjewadi, Tempo Traveller Hire in Aundh Pune, Pimpri Chinchwad to Shirdi Tempo Traveller on Rent, Tempo Traveller On Rent in Bhosari, Tempo Traveller on Rent in Nigdi Pune, Tempo Traveller on Rent in Ravet Pune, Tempo Traveller on Rent in Chinchwad"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/11.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Tempotravelleronrentinpimprichichwad;